import { render } from "./AddEmployeePage.vue?vue&type=template&id=79ba9f19&ts=true"
import script from "./AddEmployeePage.vue?vue&type=script&lang=ts"
export * from "./AddEmployeePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__